/* PROPERDRY — Collection filtering + sort (client-side prototype) */
(function () {
  'use strict';
  var grid = document.getElementById('prodGrid');
  if (!grid) return;
  var cards = Array.prototype.slice.call(grid.querySelectorAll('.card'));
  var count = document.getElementById('resultCount');

  function apply() {
    var active = {};
    document.querySelectorAll('.filter.active[data-group]:not([data-all])').forEach(function (f) {
      var g = f.getAttribute('data-group');
      (active[g] = active[g] || []).push(f.getAttribute('data-value'));
    });
    var shown = 0;
    cards.forEach(function (card) {
      var ok = Object.keys(active).every(function (g) {
        var tags = (card.getAttribute('data-' + g) || '').split(' ');
        return active[g].some(function (v) { return tags.indexOf(v) !== -1; });
      });
      card.style.display = ok ? '' : 'none';
      if (ok) shown++;
    });
    if (count) count.textContent = shown + ' product' + (shown === 1 ? '' : 's');
  }

  document.querySelectorAll('.filter').forEach(function (f) {
    f.addEventListener('click', function () {
      if (f.hasAttribute('data-all')) {
        var group = f.getAttribute('data-group');
        document.querySelectorAll('.filter[data-group="' + group + '"]').forEach(function (x) { x.classList.remove('active'); });
        f.classList.add('active');
      } else {
        var allBtn = document.querySelector('.filter[data-all][data-group="' + f.getAttribute('data-group') + '"]');
        if (allBtn) allBtn.classList.remove('active');
        f.classList.toggle('active');
        var anyActive = document.querySelectorAll('.filter.active[data-group="' + f.getAttribute('data-group') + '"]:not([data-all])').length;
        if (!anyActive && allBtn) allBtn.classList.add('active');
      }
      apply();
    });
  });

  var sort = document.getElementById('sortSel');
  if (sort) {
    sort.addEventListener('change', function () {
      var visible = cards.slice().filter(function (c) { return c.style.display !== 'none'; });
      var v = sort.value;
      visible.sort(function (a, b) {
        if (v === 'price-asc') return (+a.dataset.price) - (+b.dataset.price);
        if (v === 'price-desc') return (+b.dataset.price) - (+a.dataset.price);
        if (v === 'rating') return (+b.dataset.rating) - (+a.dataset.rating);
        return (+a.dataset.order) - (+b.dataset.order);
      });
      visible.forEach(function (c) { grid.appendChild(c); });
    });
  }

  grid.querySelectorAll('.card').forEach(function (c) {
    c.addEventListener('click', function () { window.location.href = 'product.html'; });
  });
  apply();
})();
